import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import useTestId from '@ori/testid-generator';
import { ArrowRightThin } from '@ori-ui/icons';
import { useCallback, useMemo, useLayoutEffect, useRef, useState } from 'react';
import { Content } from "./Content";
import { ContentWrapper, ImageWrapper, LinkArrow, Root } from "./styles";
import { BANNER_ARROW, BANNER_CONTENT_WRAPPER, BANNER_IMAGE, BANNER_WRAPPER } from "../../common";
import { LazyImage } from "../LazyImage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_IMAGE_WIDTH = 80;
export var Banner = function Banner(props) {
  var imageUrl = props.imageUrl,
    _props$imageWidth = props.imageWidth,
    imageWidth = _props$imageWidth === void 0 ? DEFAULT_IMAGE_WIDTH : _props$imageWidth,
    url = props.url;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var imageWrapperRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    imageWrapperWidth = _useState2[0],
    setImageWrapperWidth = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    imageWrapperHeight = _useState4[0],
    setImageWrapperHeight = _useState4[1];
  var lazyImageRef = useRef(null);
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    lazyImageWidth = _useState6[0],
    setLazyImageWidth = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    lazyImageHeight = _useState8[0],
    setLazyImageHeight = _useState8[1];
  var shouldWidthBeLarger = useMemo(function () {
    return imageWrapperWidth > imageWrapperHeight || lazyImageWidth < lazyImageHeight;
  }, [imageWrapperHeight, imageWrapperWidth, lazyImageHeight, lazyImageWidth]);
  var setLazyImageDimensions = useCallback(function () {
    if (lazyImageRef.current) {
      setLazyImageWidth(lazyImageRef.current.offsetWidth);
      setLazyImageHeight(lazyImageRef.current.offsetHeight);
    }
  }, []);
  useLayoutEffect(function () {
    if (imageWrapperRef.current) {
      setImageWrapperWidth(imageWrapperRef.current.offsetWidth);
      setImageWrapperHeight(imageWrapperRef.current.offsetHeight);
    }
  }, [setLazyImageDimensions]);
  return /*#__PURE__*/_jsxs(Root, {
    href: url,
    "data-testid": getTestId(BANNER_WRAPPER),
    children: [imageUrl ? /*#__PURE__*/_jsx(ImageWrapper, {
      ref: imageWrapperRef,
      imageWidth: imageWidth,
      shouldWidthBeLarger: shouldWidthBeLarger,
      children: /*#__PURE__*/_jsx(LazyImage, {
        alt: imageUrl,
        imageRef: lazyImageRef,
        placeholderWidth: imageWidth,
        src: imageUrl,
        testId: getTestId(BANNER_IMAGE),
        onImageLoad: setLazyImageDimensions
      })
    }) : null, /*#__PURE__*/_jsx(ContentWrapper, {
      isUrlEmpty: !url,
      "data-testid": getTestId(BANNER_CONTENT_WRAPPER),
      children: /*#__PURE__*/_jsx(Content, _objectSpread({}, props))
    }), url ? /*#__PURE__*/_jsx(LinkArrow, {
      "data-testid": getTestId(BANNER_ARROW),
      children: /*#__PURE__*/_jsx(ArrowRightThin, {})
    }) : null]
  });
};
//# sourceMappingURL=Banner.js.map